import React, { useEffect } from 'react';
import { Row, Col, Card, Input, CardBody } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useReportExamsIncomplete } from '../../../hooks/exams/useReportExamsIncomplete';
import '../../disenio/report/styleReportExamIncomplete.css'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import ScienceIcon from '@mui/icons-material/Science';
import { ToastAletGlobal } from '../../alertDialog/ToastAletGlobal';

export const IndexReportExamsIncomplete = () => {
    const history = useHistory();
    const {
        listExamsIncomplete,
        getExamsIncomplete,
        loading,
        selectMachineModels,
        selectedMachine,
        setSelectedMachine,
        getMachineModels,
        filteredExamsIncomplete, setSearchText, searchText,
        downloadExcel, loadingExcel, 

        //? TOAST ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        closeToastAlert,
    } = useReportExamsIncomplete();


    useEffect(() => {
        getExamsIncomplete();
        getMachineModels();
    }, [getExamsIncomplete, getMachineModels]);

    const handleSearch = () => {

        getExamsIncomplete(
            selectedMachine?.value || null
        );

    };

    const handleClearFilters = () => {
        setSelectedMachine(null);
        getExamsIncomplete(null);

    };

    const header = (

        <div className="report-table-header">
            <div className="report-filters-left mt-1">
                <Select
                    value={selectedMachine}
                    onChange={setSelectedMachine}
                    options={selectMachineModels}
                    isClearable
                    isSearchable
                    placeholder="Seleccionar máquina..."
                    noOptionsMessage={() =>
                        "No hay máquinas disponibles"
                    }
                    className="report-machine-select"
                    classNamePrefix="report-machine-select"
                />
                <button
                    type="button"
                    className="report-filter-btn report-filter-search"
                    onClick={handleSearch}
                >
                    <i className="pi pi-search"></i>
                    Buscar
                </button>

                <button
                    type="button"
                    className="report-filter-btn report-filter-clear"
                    onClick={handleClearFilters}
                >
                    <i className="fa fa-eraser"></i>
                    Limpiar
                </button>

                <button
                    type="button"
                    className="report-filter-btn report-filter-excel"
                    onClick={downloadExcel}
                    disabled={loadingExcel}
                >
                    {loadingExcel ? (
                        <>
                            <i className="fa fa-spinner fa-spin"></i>
                            Generando...
                        </>
                    ) : (
                        <>
                            <i className="fa fa-file-excel-o"></i>
                            Excel
                        </>
                    )}
                </button>

            </div>

            <Input
                type="search"
                placeholder="Buscar examen, máquina o método.."
                className="report-search-input"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
            />

        </div>

    );


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
        textAlign: "center"
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "6px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
        verticalAlign: "middle"
    };


    const examTemplate = (rowData) => {

        return (
            <div className="report-exam-cell">

                <span className="report-exam-code">
                    {rowData.code_exam || ""}
                </span>

                <span className="report-exam-name">
                    {rowData.name_exam || "-"}
                </span>

            </div>
        );
    };

    const machineTemplate = (rowData) => {

        const hasMachine =
            rowData.name_machine_model !== null &&
            rowData.name_machine_model !== undefined &&
            rowData.name_machine_model !== "";

        return (
            <div
                className={`report-config-cell ${
                    hasMachine
                        ? "report-config-ok"
                        : "report-config-error"
                }`}
            >
                <div className="report-config-name">
                    {hasMachine
                        ? rowData.name_machine_model
                        : "Sin máquina configurada"
                    }

                </div>

                <div
                    className={`report-config-check ${
                        hasMachine
                            ? "success"
                            : "error"
                    }`}
                >

                   <PrecisionManufacturingIcon className="mr-1 group-icon"  />

                </div>

            </div>
        );
    };

    const methodTemplate = (rowData) => {

        const hasMethod =
            rowData.name_method !== null &&
            rowData.name_method !== undefined &&
            rowData.name_method !== "";

        return (
            <div
                className={`report-config-cell ${
                    hasMethod
                        ? "report-config-ok"
                        : "report-config-error"
                }`}
            >
                <div className="report-config-name">

                    {hasMethod
                        ? rowData.name_method
                        : "Sin método configurado"
                    }
                </div>

                <div
                    className={`report-config-check ${
                        hasMethod
                            ? "success"
                            : "error"
                    }`}
                >

                   <ScienceIcon className="mr-1 group-icon"/>

                </div>

            </div>
        );
    };

    const errorTemplate = (rowData) => {

        if (!rowData.label_error) {

            return (
                <div className="report-error-success">

                    <div className="report-error-icon success">
                        <PrecisionManufacturingIcon
                            className="mr-1 group-icon"
                            fontSize="small"
                        />
                    </div>

                    <span>
                        Sin alertas
                    </span>

                </div>
            );
        }

        return (
            <div className="report-error">

                <div className="report-error-icon">
                    <i className="fa fa-exclamation" />
                </div>

                <div className="report-error-content">

                    <span className="report-error-title">
                        Configuración incompleta
                    </span>

                    <span className="report-error-message">
                        {rowData.label_error}
                    </span>

                </div>

               <button
                    type="button"
                    className="report-error-config-button"
                    title="Configurar examen"
                    onClick={() => {
                        window.open(
                            `/diseno/examenes/simple/${rowData.id_exam}`,
                            "_blank"
                        );
                    }}
                >
                    <span className="report-error-config-icon">
                        <i className="fa fa-cog"></i>
                    </span>
                </button>

            </div>
        );
    };

    return (
        <>

        <div className='container-global-zoom' style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <Card
                style={{
                    marginBottom: "15px",
                    background:"linear-gradient(135deg, #002940 0%, #1d5b83 100%)",
                    border: "none",
                    boxShadow:"0 4px 12px rgba(0,0,0,0.15)"
                }}
            >
                <CardBody style={{padding: "18px 25px"}}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight: "15px"
                                }}
                            >
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/icon-logs.svg")} style={{ width: "60px", height: "60px" }} />
                                  
                            </div>

                            <div>
                                <h4
                                    className="mb-1"
                                    style={{
                                        color: "#fff",
                                        fontWeight: 700,
                                        fontSize: "20px",
                                        textAlign: "justify"
                                    }}
                                >
                                    Reporte de exámenes interfazados incompletos
                                </h4>


                                <small
                                    style={{
                                        color:
                                            "rgba(255, 255, 255, 0.85)",

                                        fontSize: "13px"
                                    }}
                                >

                                    <i className="fa fa-info-circle mr-1"></i>
                                    Reporte de control para identificar exámenes sin configuración en equipos, integrando métodos y alertas que fortalezcan la trazabilidad.

                                </small>
                            </div>
                        </div>
                    </div>
                </CardBody>
            </Card>

            <Card>
                <Col sm="12" className='p-0'>
                    <Row>
                        <Col sm="12">
                            <div
                                style={{
                                    marginTop: "1px",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                    borderRadius: "12px",
                                    overflow: "hidden",
                                    backgroundColor: "#fff"
                                }}
                            >

                                <DataTable
                                    value={filteredExamsIncomplete}
                                    paginator
                                    loading={loading}
                                    rows={10}
                                    className="data-table p-datatable-striped p-datatable-sm"
                                    rowsPerPageOptions={[10, 50, 100]}
                                    responsiveLayout="scroll"
                                    stripedRows
                                    header={header}
                                    emptyMessage={
                                        <div className="text-center">
                                            <img
                                                src={require(
                                                    "../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg"
                                                )}
                                                style={{ width: "20%"}}
                                                alt="Sin estudios"
                                            />
                                            <br />

                                            <p
                                                className="badge badge-light-primary mt-2"
                                                style={{ fontSize: "15px"}}>
                                                sin información encontrada.
                                            </p>
                                        </div>
                                    }

                                >
                                    <Column
                                        body={(rowData, { rowIndex }) => rowIndex + 1}
                                        header="#"
                                        headerStyle={headerStyle}
                                        style={{...cellStyle, width: "45px"}}
                                    />
                                    <Column
                                        field="name_exam"
                                        header="Exámen"
                                        sortable
                                        headerStyle={headerStyle}
                                        style={{...cellStyle, mminWidth: "190px", width: "190px", textAlign: "left"}}
                                        body={examTemplate}
                                    />

                                    <Column
                                        field="name_machine_model"
                                        header="Máquina"
                                        sortable
                                        headerStyle={headerStyle}
                                        style={{ ...cellStyle, minWidth: "300px", width: "300px", padding: "4px"}}
                                        body={machineTemplate}
                                    />

                                    <Column

                                        field="name_method"
                                        header="Método"
                                        sortable
                                        headerStyle={headerStyle}
                                        style={{...cellStyle, minWidth: "300px", width: "300px", padding: "4px"}}
                                        body={methodTemplate}
                                    />

                                    <Column
                                        header="Alerta"
                                        headerStyle={headerStyle}
                                        style={{
                                            ...cellStyle,
                                            minWidth: "360px",
                                            width: "360px",
                                            textAlign: "left",
                                            padding: "5px"
                                        }}
                                        body={errorTemplate}
                                    />
                                </DataTable>
                            </div>
                        </Col>
                    </Row>
                </Col>

            </Card>
            <br /><br />
        </div>

        <ToastAletGlobal
            visible={showToast}
            type={toastType}
            title={toastTitle}
            message={toastMessage}
            onClose={closeToastAlert}
        />

        </>

    );
};